import { render, staticRenderFns } from "./EditPreferencesModal.vue?vue&type=template&id=048ba208&scoped=true"
import script from "./EditPreferencesModal.vue?vue&type=script&lang=js"
export * from "./EditPreferencesModal.vue?vue&type=script&lang=js"
import style0 from "./EditPreferencesModal.vue?vue&type=style&index=0&id=048ba208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ba208",
  null
  
)

export default component.exports